module.exports = __webpack_public_path__ + "img/online-world.ba029cf8.svg";